module.exports = __webpack_public_path__ + "c24346208019856c8935a5f5554b70b6.svg";